<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2260_15817)">
      <g clip-path="url(#clip1_2260_15817)">
        <path
          d="M20 3.99976H4C2.9 3.99976 2.01 4.89976 2.01 5.99976L2 17.9998C2 19.0998 2.9 19.9998 4 19.9998H20C21.1 19.9998 22 19.0998 22 17.9998V5.99976C22 4.89976 21.1 3.99976 20 3.99976ZM20 7.99976L12 12.9998L4 7.99976V5.99976L12 10.9998L20 5.99976V7.99976Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2260_15817">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_2260_15817">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 -0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
